import React from "react";
import { Link } from "react-router-dom";

export default function TermsAndConditions() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#f7f8fa] to-[#e6e9f5] py-12 px-4">
      <div className="w-11/12 sm:w-full sm:max-w-6xl mx-auto bg-white rounded-2xl shadow-xl p-8 border border-[#e5e7eb]">
        <div className="mb-6">
          <h1 className="text-4xl font-extrabold text-[#2d348f] mb-4 text-center">
            Terms and Conditions
          </h1>
        </div>

        <div
          className="bg-gray-50 rounded-lg p-4 mb-6"
          style={{ height: "70vh" }}
        >
          <iframe
            src="/S.A.L.Mine_Website Terms of Use 08_05_2025 redline.pdf"
            className="w-full h-full rounded border-2 border-gray-200"
            title="Terms and Conditions"
          />
        </div>

        <div className="text-center">
          <Link
            to="/signup"
            className="inline-block px-6 py-3 bg-[#2d348f] text-white font-semibold rounded-lg shadow-md hover:bg-[#4962d8] transition-all"
          >
            Back to Sign Up
          </Link>
        </div>
      </div>
    </div>
  );
}
